import React from "react";
import './TodoItem.css'

function TodoItem(props){


    return( 
    <div className="TodoItem">
        <div className="Items">
            <div onClick={props.onComplete}
            className={`Icon Icon-check ${props.completed && 'Icon-check--active'}`}>
            <i className="bi bi-check-circle"></i>
            </div>
            <div>
            <p className={`TodoItem-p ${props.completed && 'TodoItem-p--complete'}`}>
                {props.text}
            </p>
            </div> 
            <div onClick={props.onDelete} className="Icon Icon-delete">
            <i className="bi bi-x-circle"></i>
            </div>
        </div>
    </div>
    );
}

export {TodoItem};